import { createStore, compose } from 'redux'
// import { persistStore } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';

import rootReducer from './reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer(),
  composeEnhancers()
);

// persistStore(store);

export default store;



// WEBPACK FOOTER //
// ./src/store.js